import { render } from "./ClientList.vue?vue&type=template&id=be0d6098"
import script from "./ClientList.vue?vue&type=script&lang=js"
export * from "./ClientList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/ClientList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "be0d6098"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('be0d6098', __exports__)) {
    api.reload('be0d6098', __exports__)
  }
  
  module.hot.accept("./ClientList.vue?vue&type=template&id=be0d6098", () => {
    api.rerender('be0d6098', render)
  })

}


export default __exports__